import React from 'react';
import { I_FlightInfos } from '@Redux/search/interfaces';
import { I_UrlParams } from '../interfaces/search';
import { member, homeDomain, lionDomain } from '@utils/domainByEnv';

// Data Checking ============================
// 檢查是否為【Travelfusion 供應商】
export const isTFGDS = (supplier: string) => supplier == 'TRAVELFUSION';

// 檢查是否為【套裝方案】
export const isSuitPlan = (farefamily: any) => !!farefamily;

// Data Filtering ===========================
// 篩選出還有座位的資料
export const filterSeatAvailable = (data: I_FlightInfos[]) => {
    if (!data || data?.length === 0) return false;
    return data.filter((item: I_FlightInfos) => item.FareInfos[0].AdtAvailSeats !== 0);
};

// Data Sorting =============================
// export const sortData = (data: any, sortBaseObj: { identifier: string; orderBaseArr: string[]; orderBy?: 'ASC' | 'DESC' }) => {
//     if (!data || data.length === 0) return []
//     const { identifier, orderBaseArr, orderBy = "ASC" } = sortBaseObj;


//     const getPosition = (curIdentifier: string) => {
//         if (orderBaseArr.indexOf(curIdentifier) < 0) { console.error(`Unknown ${identifier} value: ${curIdentifier}`) }
//         return orderBaseArr.indexOf(curIdentifier);
//     }
//     const sortedData = JSON.parse(JSON.stringify(data)).sort(
//         (a: any, b: any) => {
//             if (orderBy === "ASC") return (a[identifier]) - (b[identifier]);
//             if (orderBy === "DESC") return (b[identifier]) - (a[identifier]);
//         }
//     );

//     return sortedData
// };

// Data Getting =============================
// 取得航空公司 icon URL
export const getIconImageURL = (airportCode?: string) => {
    if (!airportCode) return `https:${lionDomain}/Images/carr/default.png`;
    return `https:${lionDomain}/Images/carr/${airportCode}.png`
};


export const getSearchUrlParams = (): I_UrlParams => {
    const urlParams = new URLSearchParams(location.search);
    const Rtow = urlParams.get('Rtow') || '1';
    const ClsType = urlParams.get('ClsType') ?? '0';
    const Adt = Math.max(Number(urlParams.get('Adt')!), 1);
    const Chd = Number(urlParams.get('Chd')!) || 0;
    const Inf = Number(urlParams.get('Inf')!) || 0;

    const Depart1 = urlParams.get('Depart1')!;
    const Arrive1 = urlParams.get('Arrive1')!;

    const DepCity1 = urlParams.get('DepCity1')!;
    const ArrCity1 = urlParams.get('ArrCity1')!;

    const NoTrans = urlParams.get('NoTrans') === 'T' ? true : false;

    const PreferAirlines = urlParams.get('PreferAirlines') ?? '';
    const SeekLcc = urlParams.get('SeekLcc') ?? '0';
    const Cd = urlParams.get('Cd') ?? '0';

    return {
        Rtow,
        ClsType,
        Adt,
        Chd,
        Inf,
        PreferAirlines,
        SeekLcc,
        Depart1,
        Arrive1,
        DepCity1,
        ArrCity1,
        NoTrans, // URL
        NonStop: NoTrans, // Request Param
        Cd
    };
};

// 用 URL 中的 Rtow 取得對應顯示文字
export const getRtowText = (URLRtow: string) => {
    switch (URLRtow) {
        case RTOW_SINGLE:
            return '單程';
        case RTOW_RETURN:
            return '來回';
        case RTOW_MULTI:
            return '多目的地';
        default:
            return '來回';
    }
};

export const RTOW_SINGLE = '0';
export const RTOW_RETURN = '1';
export const RTOW_MULTI = '3';


// Redirecting ==============================
// 明細頁送出資料
export const goPage = (ref: React.RefObject<HTMLFormElement>) => ref?.current?.submit();

export const handleGoPassenger = (
    { agree, isLogin, isMobile, isSalesMode, formRef }: {
        agree: boolean,
        isLogin: boolean,
        isMobile: boolean,
        isSalesMode: boolean,
        formRef: React.RefObject<HTMLFormElement>
    }
) => {
    if (!agree) {
        const warningContent = '請閱讀完訂位與購票須知的內容後，勾選我同意之選項再繼續下一步。';
        return alert(warningContent);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const urlArray = urlParams.toString().split('&');
    const req: object | any = {};

    urlArray.forEach((item) => {
        const key = item.match(/^\w*[^=]*/g) ? item.match(/^\w*[^=]*/g) : '';
        const value = item.match(/[^=]*\w$/g) ? item.match(/[^=]*\w$/g) : '';

        if (!!key && !!value) req[`${key[0]}`] = value[0];
    });

    // 已登入 把參數用 post 傳過去
    // 若在業務模式salesmode下，不需彈出會員登入光箱，要直接跳轉到旅客頁
    if (isLogin || isSalesMode) {
        goPage(formRef);
        return;
    }

    // 未登入 開啟登入光箱
    // 邏輯是 開啟光箱時將網址帶上 會轉回原址並且帶上參數
    // sessionStorage.lightSpeedProduct 轉回原址時 利用 sessionStorage 的資料再去 post
    // 轉址
    sessionStorage.lightSpeedProduct = JSON.stringify(req);
    const lightSpeedProduct = encodeURIComponent(
        JSON.stringify({
            productID: '4',
            redirectUrl: encodeURIComponent(location.href),
        })
    );

    if (!isMobile) {
        $('#lionLogin').trigger('setUrlParams', [
            {
                lightSpeedProduct: lightSpeedProduct,
            },
            'login',
        ]);
        $('#lionLogin').trigger('open', ['login']);
    } else {
        const redirectUrl = `https:${member}/account/login?lightSpeedProduct=` + lightSpeedProduct;
        location.href = redirectUrl.replace(/&amp;/g, '&');
    }
};

// 出現狀況，導回搜尋結果頁
export const redirectToSearch = (alertText: string) => {
    // ?setTimeout(() => alert(alertText), 0);
    alert(alertText);
    const url = new URLSearchParams(window.location.search);
    url.delete('TransactionKey');
    url.delete('SearchKey');
    url.delete('FlightFareInfoKey');
    window.location.replace(`${homeDomain}/search?${url.toString()}`);
};

// 尚未使用的 tool functions ===========================

// 將文案限制顯示上限字數 (超過設定數量則會擷取後在最後接上 "...")
export const limitTextLength = (text: string, limitLength: number) =>
    text.length > limitLength ? `${text.slice(0, limitLength)}...` : text;

// ! 待刪 (不知道要幹嘛)
// interface I_UpdateFilterProps {
//     data: I_FilterItem[];
//     nowType: string;
//     text: string;
//     value: number | string;
//     subValue: string;
//     priceDefaultRange?: number[]; // 價錢初始最大最小值
// }
/** @summary 篩選掉目前傳入的item
 * @param props I_UpdateFilterProps
 * @returns 剩下未被篩選掉的item
 */
// export const updateFilterItems = (props: I_UpdateFilterProps) => {
//     const { data, nowType, value, text, subValue, priceDefaultRange } = props;
//     const newItems = JSON.parse(JSON.stringify(data));

//     switch (subValue) {
//         case 'min':
//         case 'max': {
//             const isMatchPrice = newItems.filter((item: I_FilterItem) => {
//                 const isSameSubValue = item.subValue === subValue;
//                 return isSameSubValue;
//             });
//             // 如果是相同min or max 則更新成新值
//             newItems.forEach((item: I_FilterItem, idx: number, arr: []) => {
//                 const istSameType = item.filterBy === nowType;
//                 const isSameSubValue = item.subValue === subValue;
//                 if (istSameType && isSameSubValue) {
//                     const initMin = priceDefaultRange && priceDefaultRange[0];
//                     const initMax = priceDefaultRange && priceDefaultRange[1];
//                     if (subValue === 'min' && value === initMin) {
//                         arr.splice(idx, 1);
//                     } else if (subValue === 'max' && value === initMax) {
//                         arr.splice(idx, 1);
//                     } else {
//                         item.text = text;
//                         item.value = value;
//                     }
//                 }
//             });

//             if (isMatchPrice.length === 0) {
//                 // 無選到已有選項則新增一個
//                 newItems.push({
//                     filterBy: nowType,
//                     text,
//                     value,
//                     subValue,
//                 });
//             }
//             return newItems;
//         }

//         default: {
//             // 回傳目前點到的項目是否已在目前篩選陣列中
//             const isMatch = newItems.filter((item: I_FilterItem) => {
//                 return item.filterBy === nowType && item.value == value;
//             });

//             // 回傳所有 非相同類別 或 同類別但不同值
//             const notMatchItem = newItems.filter((item: I_FilterItem) => {
//                 const istSameType = item.filterBy === nowType;
//                 const isSameValue = item.value == value;
//                 return !istSameType || (istSameType && !isSameValue);
//             });
//             if (isMatch.length === 0) {
//                 // 無選到已有選項則新增一個
//                 newItems.push({
//                     filterBy: nowType,
//                     text,
//                     value,
//                     subValue,
//                 });
//                 return newItems;
//             } else {
//                 // 選到已有選項則回傳已被篩掉重複的選項陣列
//                 return notMatchItem;
//             }
//         }
//     }
// };